import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import api from "../../utils/api";
// import querystring from "querystring";
import TextContent from "../TextContent";
import UseQuery from "../../utils/useQuery";
import { withRouter } from "react-router-dom";

class Unsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unsubscribed: false,
      apiFailed: false,
      hasError: false,
      errorMessage: null
    };
  }
  componentDidMount() {
    this.doUnsubscribe();
  }

  doUnsubscribe() {
    const { fields, link } = this.props;
    const { unsubscribedError, defaultErrorText } = fields;
    const query = UseQuery();
    if (query.email) {
      api
        .unbind(null, {
          email: query.email,
          token: query.token
        })
        .then(res => {
          switch (res.code) {
            case "1":
              api.leads.update(null, {
                email: query.email
              });
              if (link && link.value.href) {
                this.history.push(link.value.href);
              } else {
                this.setState({
                  unsubscribed: true
                });
              }
              break;
            case "CUSTOMER_SUBSCRIPTION_001":
              this.setState({
                unsubscribed: true,
                hasError: true,
                errorMessage: unsubscribedError ? unsubscribedError.value : res.msg
              });
              break;
            // case "CUSTOMER_SUBSCRIPTION_006":
            //   this.setState({
            //     unsubscribed: true
            //   });
            //   break;
            default:
              this.setState({
                unsubscribed: true,
                apiFailed: true,
                errorMessage: defaultErrorText ? defaultErrorText.value : res.msg
              });
              break;
          }
        })
        .catch(err => {
          switch (err.code) {
            case "CUSTOMER_SUBSCRIPTION_001":
              this.setState({
                unsubscribed: true,
                hasError: true,
                errorMessage: unsubscribedError ? unsubscribedError.value : err.msg
              });
              break;
            // case "CUSTOMER_SUBSCRIPTION_006":
            //   this.setState({
            //     unsubscribed: true
            //   });
            //   break;
            default:
              this.setState({
                unsubscribed: true,
                apiFailed: true,
                errorMessage: defaultErrorText ? defaultErrorText.value : err.msg
              });
              break;
          }
        });
    } else {
      this.setState({
        unsubscribed: true,
        apiFailed: true,
        errorMessage: defaultErrorText ? defaultErrorText.value : "System Error"
      });
    }
  }
  render() {
    const { fields, rendering } = this.props;
    const { apiFailed, hasError, errorMessage } = this.state;
    console.dir(fields);
    if (!fields) return null;
    if (!this.state.unsubscribed) {
      return null;
    }
    const { alignment, backgroundColor } = fields;
    const background = backgroundColor && backgroundColor.fields && backgroundColor.fields.phrase ? backgroundColor.fields.phrase.value : null;
    const unsubscribeClasses = classNames("unsubscribe", "grid", {
      center: alignment && alignment.fields.phrase.value === "center",
      right: alignment && alignment.fields.phrase.value === "right"
    });
    const unsubscribeStyles = {
      background
    };
    return (
      <div className={unsubscribeClasses} style={unsubscribeStyles} datasourceid={rendering.dataSource}>
        {!apiFailed && <TextContent {...this.props} />}
        {(hasError || apiFailed) && errorMessage && (
          <div className="error-message">
            <RichText field={{ value: errorMessage }} tag={"p"} />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Unsubscribe);
